import type { Config } from "../schema";

const config: Config = {
  API_BASE_URLS: {
    BEST_FARE_FINDER: "https://jbrest.jetblue.com/bff-service-v2",
    ORIGIN_DESTINATION: "https://azrest.jetblue.com/od/od-service",
  },
  APPS: {
    ANDROID: {
      APP_ID: "com.jetblue.JetBlueAndroid",
      PLAY_STORE_URL:
        "https://play.google.com/store/apps/details?id=com.jetblue.JetBlueAndroid&hl=en_US",
    },
    IOS: {
      APP_ID: "481370590",
      APP_STORE_URL:
        "https://apps.apple.com/us/app/jetblue-book-manage-trips/id481370590",
    },
  },
  ASAPP: {
    ASAPP_APP_ID: "jetblue",
    ASAPP_AUTO_OPEN_ON_LOAD_URLS: ["/contact-us/chat-ivr", "/contact-us/chat"],
    ASAPP_CAN_BEGIN_CHAT_URLS: [
      "/contact-us",
      "/contact-us/chat",
      "/contact-us/chat-ivr",
      "/safety/fraud-prevention",
    ],
    ASAPP_HOSTNAME: "jetblue.asapp.com",
    SHERPA_AFFILIATE_ID: "jetblue",
    SHERPA_APP_ID: "spY3MjM0OT",
  },
  AUTH: {
    AUTH_KIT_COOKIE_NAME: "dotcom-kit-auth",
    AUTH_KIT_COOKIE_VALUE: "kit-auth",
    CLIENT_ID: "0oa6pzarfiDxq8sn32p7",
    EXCLUDED_ROUTES: ["logout"],
    HANDLE_RETURN_URL: true,
    IDLE_TIMER_DURATION: 240,
    IS_AUTH_KIT_COOKIE_ENABLED: false,
    IS_ENABLED: true,
    IS_PRODUCTION: true,
    ISSUER: "https://accounts.jetblue.com/oauth2/aus63a5bs52M8z9aE2p7",
    LOGOUT_WHEN_IDLE: true,
    POST_LOGOUT_REDIRECT_URI: "https://www.jetblue.com",
    PROFILE_URL: "",
    REDIRECT_URI: "https://www.jetblue.com/login-callback",
    SIGN_IN_URL: "https://www.jetblue.com/signin",
    STORAGE: "localStorage",
    USE_KIT_AUTH: false,
    WEB_COMPONENT_SRC:
      "https://static.jetblue.com/49b10c8ad172622fbc74/dist/wc-auth-wrapper/wc-auth-wrapper-element.js",
  },
  BAG_CALCULATOR: {
    API_URL: "https://cb-api.jetblue.com/cb-baggage-fee-calculator/v1",
  },
  BRAZE: {
    BRAZE_API_KEY: "786dbf53-57df-423f-8d9f-690d3bf2633d",
    BRAZE_SRC: "https://js.appboycdn.com/web-sdk/6.3/braze.min.js",
  },
  CB: {
    GATEKEEPER_URL:
      "https://cb-api.jetblue.com/cb-gatekeeper/v1/gatekeeper/flags",
    LOGGER_URL:
      "https://static.jetblue.com/243baff993e46b2c0433/felog/felog.js",
  },
  DY_SECTION_ID: "8791140",
  FEATURE_FLAGS: {
    DATA_THEME: "v4",
    FLIGHT_SEARCH_FORM: {
      IS_DATE_PICKER_PRICING_ENABLED: true,
    },
    IS_HEADER_BG_WHITE_ENABLED: true,
  },
  FULLSTORY_ORG_ID: "4HV1Q",
  GTM_ID: "GTM-5J92P6SM",
  MAZE: {
    MAZE_API_KEY: "31c95ee6-123f-4709-a960-96daab07509f",
    MAZE_LOADER_URL: "https://snippet.maze.co/maze-universal-loader.js",
  },
  MGNL: {
    API_NAV: "/.rest/delivery/pagenav/v1",
    API_PAGES: "/.rest/delivery/pages/v1",
    API_TEMPLATES: "/.rest/template-annotations/v1",
    DRAFT_TOKEN: "my_secret_token",
    EDIT: "https://cms.jetblue.com/author",
    IMAGE_BASE: "https://cms.jetblue.com/dam",
    LANGUAGES: ["en", "es", "fr", "it"],
    PUBLIC: "https://cms.jetblue.com/public",
    SITE_PATH: "/dotcom",
  },
  PAISLY_JTP: {
    SCRIPT_URL:
      "https://api.paisly.jetblue.com/jtpsdk/api/v1?client=jetbluecom",
    TRACKING_SCRIPT_URL:
      "https://api.paisly.jetblue.com/apis/jtpsdkping?client=jbresponsivebooking",
  },
  PLUSGRADE: {
    API_KEY: "UJ2CifwKMdPgTS9kHv8TcMY3",
    ELIGIBILITY_WIDGET_ENV_SCRIPT_URL: "",
    ELIGIBILITY_WIDGET_SCRIPT_URL:
      "https://canvas.plusgrade.com/eligibilityWidget/eligibilityWidget.js",
    PID: "vp2icnHOB6",
    SHOULD_LOAD_NPRD_ENV_SCRIPT: false,
  },
  QUALTRICS: {
    QUALTRICS_INTERCEPT_ID: "ZN_9NrVZpkFcamQFbo",
    QUALTRICS_IS_ENABLED: true,
    QUALTRICS_SRC:
      "https://zn9nrvzpkfcamqfbo-jetbluevoc.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_9NrVZpkFcamQFbo",
  },
  TRUST_ARC_URL:
    "https://consent.trustarc.com/notice?domain=jetblue.com&c=teconsent&js=nj&noticeType=bb&gtm=1",
  VERTEX_SEARCH: {
    API_URL:
      "https://www-stg2.jetblue.com/api/dotcom/cb-dotcom-search/v1/content/search",
  },
};

export default config;
